import "./Dentures.module.css";
import Header from "../../reusable_sections/Header";
import Footer from "../../reusable_sections/Footer";
import Hero from "./sections/Hero";
import TechnologyExecution from "./sections/TechnologyExecution";
import HowNvAcademyWorks from "./sections/HowNvAcademyWorks";
import Faqs from "./sections/Faqs";
export default function DenturesPage() {
  return <div>
      <Header />
      <Hero />
      <TechnologyExecution />
      <HowNvAcademyWorks />
      <Faqs />
      <Footer />
    </div>;
}